import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Modal } from './modal';
import ModalFooter from './ModalFooter';
import Typography from './Typography';
import vmTheme from '../constants/theme';
import { font } from '../constants/font';

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  gap: 33px;
`;

export const SpaceUnavailableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 24px;
  
`;


const DeleteModal = ({ text, subText, confirmText, onCloseModal, onSave, bgColor }) => {
    const theme = useSelector((state) => state.app.get("theme"));

    return (
        <Modal
            showModal={true}
            useWrapper={false}
            onClose={() => onCloseModal(false)}
            borderRadius="16px"
            width={"396px"}
            height={"auto"}
        >
            <SpaceUnavailableWrapper>
                <TextContainer>
                    <Typography
                        content={text}
                        color={vmTheme[theme].panelPrimaryColor}
                        font={font.bold_16}
                        align="start"
                    />
                    <Typography
                        content={subText}
                        color={vmTheme[theme].panelPrimaryColor}
                        font={font.bold_16_400}
                        align="start"
                        enableTrim={false}
                    />
                    <ModalFooter
                        onSave={onSave}
                        confirmText={confirmText}
                        cancelText={"Cancel"}
                        onClose={() => onCloseModal(false)}
                        fontsColor={vmTheme[theme].polarColor}
                        backgroundColor={bgColor || vmTheme[theme].textboxErrorColor}
                        cancelBackground={ vmTheme[theme].btnBgLightColor}
                        showHoverColor={false}
                        padding={"1px"}
                    />
                </TextContainer>
            </SpaceUnavailableWrapper>
        </Modal>
    );
};

DeleteModal.propTypes = {
    text: PropTypes.string,
    subText: PropTypes.string,
    confirmText: PropTypes.string,
    onCloseModal: PropTypes.func,
    onSave: PropTypes.func,
    bgColor: PropTypes.string,
};

export default DeleteModal;